import { useContext } from 'react';
import { ConfigContext } from '../providers/ConfigContext';
import useMakeApiRequest from '../utils/makeApiRequest';

const useMakeSale = () => {
	const { apiBase } = useContext(ConfigContext);
	const makeApiRequest = useMakeApiRequest('POST');

	const makeSale = async (body: any) => {
		const url = `${apiBase}/api/transactions/sale`;
		return makeApiRequest(url, body);
	};
	return [makeSale];
};

export default useMakeSale;
